<template>
  <page-edicion>
    <page-header title="Crear contrato" back-to="/contratos" />
    <formulario-contrato-cliente :contrato-cliente="contratoCliente" @submit="insertar" />
  </page-edicion>
</template>

<script>
import FormularioContratoCliente from "./FormularioContratoCliente.vue";
import contratosClienteApi from "@/services/contratosCliente.js";

export default {
  components: { FormularioContratoCliente },
  data() {
    return {
      contratoCliente: contratosClienteApi.crear(),
    };
  },
  methods: {
    insertar() {
      const contratoCliente = { contratoCliente: this.contratoCliente };
      contratosClienteApi.insertar(contratoCliente).then(() => {
        this.$router.push({ path: "/contratos" });
      });
    },
  },
};
</script>
